module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"field-placeholder":"Drücken Sie irgend einen Knopf","btn-save-text":"Übernehmen"},"fr":{"btn-save-text":"Accepter","field-placeholder":"Appuyez sur n’importe quel bouton"},"it":{"btn-save-text":"Acquisire","field-placeholder":"Prema un tasto qualsiasi"}}')
  delete Component.options._Ctor
}
